import { TYPES } from 'components/modules/Insurance/components/VinOrBodyNumberInput/VinOrBodyNumberInput.constants';
import { InputMask } from 'utils/inputMask';

export const VIN_OR_BODY_NUMBER_LABELS = {
  [TYPES.BODY]: 'Номер кузова',
  [TYPES.VIN]: 'VIN',
};
export const VIN_OR_BODY_NUMBER_MASKS = {
  [TYPES.BODY]: InputMask.VIN_BODY,
  [TYPES.VIN]: InputMask.VIN_NEW,
};
